module.exports = __webpack_public_path__ + "media/images/placeholder-posted-jobs-76c643e9.png";